import { useLocalStorage } from "./useLocalStorage"
import { useFeatFlags } from "../../components/providers/FeatFlagProvider"
import { ENV, GMAPS_MAP_ID, GMAPS_TYPE_ID, MAP_PROVIDER, MAP_STYLE_KEY } from "../config"

// possible map providers
export type MapProvider = "mapbox" | "google_maps"

// Mapbox
export const MAPBOX_STYLES = {
  LIGHT: "noatechnologiesinc/cl7eomzti000514pqu66na9kc",
  DARK: "mapbox/dark-v10",
  COLOR: "mapbox/outdoors-v11",
  SATELLITE: "noatechnologiesinc/cllxj39bx00j501qx7sq5bspq",
}

export type MapboxStyle = typeof MAPBOX_STYLES[keyof typeof MAPBOX_STYLES]

// Google Maps
export type GoogleMapsType = "roadmap" | "hybrid"

export const GOOGLE_MAPS_IDS =
  ENV === "production"
    ? {
        LIGHT: "e5e0bfb75bd09082",
        DARK: "a5b6205a77b0b263",
        COLOR: "9a3f42fd1a2301f",
        SATELLITE: "814662d1181361c8",
      }
    : {
        LIGHT: "56fb5b5bc32efb27",
        DARK: "af900230874e38c7",
        COLOR: "4810de723a30fc21",
        SATELLITE: "36d791700011dd87",
      }

export type GoogleMapsId = typeof GOOGLE_MAPS_IDS[keyof typeof GOOGLE_MAPS_IDS]

// hooks
export function useMapboxMapStyle() {
  return useLocalStorage<MapboxStyle>(MAP_STYLE_KEY, MAPBOX_STYLES.LIGHT)
}

export const useGoogleMapsTypeId = () => {
  return useLocalStorage<GoogleMapsType>(GMAPS_TYPE_ID, "roadmap")
}

export const useGoogleMapsMapId = () => {
  return useLocalStorage<GoogleMapsId>(GMAPS_MAP_ID, GOOGLE_MAPS_IDS.LIGHT)
}

export const useMapProvider = () => {
  const { google_maps } = useFeatFlags()
  const initValue = google_maps?.visible ? "google_maps" : "mapbox"
  return useLocalStorage<MapProvider>(MAP_PROVIDER, initValue)
}
